// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
});

// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
});

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
});

// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.
document.addEventListener("product:variant-change", function (evt) {
  console.log("Product variant changed");
  console.log(evt.detail.variant);
  var variant = evt.detail.variant;
  var colorValue = typeof getSelectedColor === "function" ? getSelectedColor() : null;

  if (!colorValue && variant && variant.options) {
    colorValue = variant.options[0];
  }

  // updateProductTitle(colorValue);
  if (typeof updateSmartDescription === "function") {
    updateSmartDescription(variant);
  }

  // --- PRE-ORDER POPUP LOGIC ---
  const atcButton = document.querySelector('.product-form__cart-submit');
  const variantSelector = document.querySelector('#variant-selector');
  const customModal = document.querySelector('#preorder-modal'); // Null if disabled in settings
  const modalTextContainer = document.querySelector('.jl-modal-text');
  
  // Only proceed if elements exist AND the popup is enabled (customModal is present)
  if (atcButton && variantSelector && customModal && variant) {
    const selectedOption = variantSelector.querySelector(`option[value="${variant.id}"]`);
    
    if (selectedOption) {
      const inventoryLevel = parseInt(selectedOption.getAttribute('data-variant-inventory'), 10) || 0;
      const isAvailable = selectedOption.getAttribute('data-available') === 'true';

      if (isAvailable && inventoryLevel <= 0) {
        // 1. Add trigger class
        atcButton.classList.add('trigger-preorder-popup');
        
        // 2. Update Popup Text (Metafield vs Fallback)
        if (modalTextContainer) {
          const variantText = selectedOption.getAttribute('data-variant-delivery-text');
          
          if (variantText && variantText.trim() !== '') {
            // Inject Metafield HTML
            modalTextContainer.innerHTML = modalTextContainer.getAttribute('data-default-text').replace('[delivery_message]',variantText);
          } else {
            // Revert to section settings default text (stored on load)
            modalTextContainer.innerHTML = modalTextContainer.getAttribute('data-default-text').replace('[delivery_message]','2-4 weeks');
          }
        }
      } else {
        atcButton.classList.remove('trigger-preorder-popup');
      }
    }
  }
  // ------------------------------------------------

  // Remove ?color and ?hardware from URL
  var params = new URLSearchParams(window.location.search);
  if (params.has('color') || params.has('hardware')) {
    params.delete('color');
    params.delete('hardware');
    var cleanUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
    window.history.replaceState({}, '', cleanUrl);
  }
  if(window.innerWidth > 768){
    const current_url = window.location.href.toLowerCase();
    if (current_url.includes("gift-card")) {
      document.querySelector(".product-thumbnails__item-link[data-thumbnail-id='"+variant.featured_media.id+"']").click();
    }
  }
});

// This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.
document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
});

// This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.
document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
});

// ── Append selected Color variant to product title ───────────────────────
function getSelectedColor() {
  var selects = document.querySelectorAll('[name^="options["]');
  for (var i = 0; i < selects.length; i++) {
    var name = selects[i].name.replace('options[', '').replace(']', '').toLowerCase();
    if (name === 'color') return selects[i].value;
  }
  var labels = document.querySelectorAll('.product__label');
  for (var j = 0; j < labels.length; j++) {
    if (labels[j].textContent.toLowerCase().includes('color')) {
      var valueSpan = labels[j].querySelector('[data-selected-value-for-option]');
      if (valueSpan) return valueSpan.textContent.trim();
    }
  }
  return null;
}

function updateProductTitle(colorValue) {
  var titleEl = document.querySelector('.product__title');
  if (!titleEl) return;

  if (!titleEl.dataset.baseTitle) {
    titleEl.dataset.baseTitle = titleEl.textContent.trim();
  }

  titleEl.textContent = colorValue
    ? titleEl.dataset.baseTitle + ' ' + colorValue
    : titleEl.dataset.baseTitle;
}


// ── Smart description: variant_description > series_description ──────────
// Reads all variant descriptions from the embedded JSON script tag on page load.
// On variant change, looks up the new variant ID in the JSON and updates
// the description element. Falls back to series_description if no variant
// description exists. Hides the block if both are empty.
// ─────────────────────────────────────────────────────────────────────────
function updateSmartDescription(variant) {
  var descEl  = document.getElementById('product-smart-description');
  var dataEl  = document.getElementById('variant-descriptions-data');
  if (!descEl || !dataEl || !variant) return;

  var data = {};
  try {
    data = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  var variantDesc     = data.variants && data.variants[String(variant.id)] ? data.variants[String(variant.id)] : '';
  var seriesDesc      = data.series_description || '';
  var wrapper         = descEl.closest('.product__description');
  var hasColorVariant = descEl.dataset.hasColorVariant === 'true';
  var displayDesc     = '';

  if (hasColorVariant) {
    displayDesc = variantDesc || seriesDesc;
  } else {
    displayDesc = seriesDesc;
  }

  if (displayDesc) {
    descEl.innerHTML = displayDesc;
    if (wrapper) wrapper.style.display = '';
  } else {
    if (wrapper) wrapper.style.display = 'none';
  }
}

// ── URL parameter variant pre-selection ──────────────────────────────────
// Usage: ?color=Yellow&hardware=Gold
// Waits for window load + 300ms so the theme's swatch click handlers are
// fully attached, then clicks the matching swatch button directly.
// No page reload — uses history.replaceState to clean up params after.
// ─────────────────────────────────────────────────────────────────────────
window.addEventListener('load', function () {
  var params        = new URLSearchParams(window.location.search);
  var colorParam    = params.get('color');
  var hardwareParam = params.get('hardware');

  if (!colorParam && !hardwareParam) {
    //updateProductTitle(getSelectedColor());
    return;
  }

  // Wait for theme swatch handlers to be fully attached
  setTimeout(function () {

    if (colorParam) {
      document.querySelectorAll('[data-option-value]').forEach(function (btn) {
        if (btn.getAttribute('data-option-value').toLowerCase() === colorParam.toLowerCase()) {
          btn.click();
        }
      });
    }

    if (hardwareParam) {
      document.querySelectorAll('[data-option-value]').forEach(function (btn) {
        if (btn.getAttribute('data-option-value').toLowerCase() === hardwareParam.toLowerCase()) {
          btn.click();
        }
      });
    }

    // Clean up color/hardware from URL without reload
    params.delete('color');
    params.delete('hardware');
    var cleanUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
    window.history.replaceState({}, '', cleanUrl);

    setTimeout(function () {
      //updateProductTitle(getSelectedColor());
    }, 100);

  }, 300);
});


// Color filter title prefix — runs on collection pages only
(function() {
  if (!window.location.pathname.includes('/collections/')) return;

  var params = new URLSearchParams(window.location.search);
  var colors = params.getAll('filter.v.option.color');
  if (!colors.length) return;

  var colorLabel = colors.map(function(c) {
    return c.charAt(0).toUpperCase() + c.slice(1).toLowerCase();
  }).join(' & ');

  // Encodes plain text to match HTML entity format inside innerHTML
  function htmlEncode(str) {
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function applyColorTitle() {
    var collectionTitle = '';

    // 1. Update the collection banner h1
    var h1Selectors = [
      '.collection-banner__text-container-heading',
      '.main-collection-banner h1',
      'h1.section-blocks__heading'
    ];
    for (var i = 0; i < h1Selectors.length; i++) {
      var h1 = document.querySelector(h1Selectors[i]);
      if (h1 && !h1.dataset.colorPrefixed) {
        h1.dataset.colorPrefixed = '1';
        collectionTitle = h1.textContent.trim(); // "Handbags & clutches"
        h1.textContent = colorLabel + ' ' + collectionTitle;
        break;
      }
    }

    // Fallback: get collection title from og:title meta tag
    if (!collectionTitle) {
      var ogTitle = document.querySelector('meta[property="og:title"]');
      if (ogTitle) collectionTitle = ogTitle.getAttribute('content').trim();
    }

    if (!collectionTitle) return;

    // 2. Update rich-text h2
    // Must encode title to match &amp; entities inside innerHTML
    var encodedTitle = htmlEncode(collectionTitle);
    var encodedColorLabel = htmlEncode(colorLabel);

    document.querySelectorAll('.rich-text__heading').forEach(function(h2) {
      if (!h2.dataset.colorPrefixed && h2.innerHTML.indexOf(encodedTitle) !== -1) {
        h2.dataset.colorPrefixed = '1';
        h2.innerHTML = h2.innerHTML.replace(
          encodedTitle,
          encodedColorLabel + ' ' + encodedTitle
        );
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyColorTitle);
  } else {
    applyColorTitle();
  }
})();

// Close nav dropdown when same-page anchor links are clicked inside the menu
(function() {
  document.addEventListener('click', function(e) {
    var link = e.target.closest('a[href*="#"]');
    if (!link) return;

    // Only act on links inside the navigation
    if (!link.closest('.header__links-list') && !link.closest('.meganav')) return;

    var href = link.getAttribute('href') || '';
    var hash = href.split('#')[1];

    // Must be a same-page anchor (has a hash and the target element exists on this page)
    if (!hash || !document.getElementById(hash)) return;

    // Simulate a click on the body — triggers the theme's handleClick → closeAll()
    setTimeout(function() {
      document.body.click();
    }, 50);
  });
})();

import(flu.chunks.swiper).then(_ref => {
  let {
    Swiper,
    Pagination,
    Navigation
  } = _ref;
  let desktopCarouselSelector = '.product__media-container.swiper.above-mobile';
  this.desktopSwiper = new Swiper(desktopCarouselSelector, {
     modules: [Pagination,Navigation],
        slidesPerView: 'auto',
        freeMode: true,
        spaceBetween: 0,
        grabCursor: true,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: desktopCarouselSelector +" .carousel__navigation-button--forward",
          prevEl: desktopCarouselSelector +" .carousel__navigation-button--back"
        },
        watchSlidesProgress: true,
        loop: false,
        autoHeight: false
  });
  window.desktopSlider = this.desktopSwiper;
  this.desktopSwiper.on("slideChange", evt => {
   
  });
});


// ── Customize + Wishlist side-by-side layout ─────────────────────────────
var _wishlistOriginalParent  = null;
var _wishlistOriginalSibling = null;

function applyWishlistLayout() {
  var customizeBtn  = document.querySelector('.product-form__customize-btn');
  var wishlistBlock = document.querySelector('.shopify-app-block[id*="wishlist"]');

  if (!wishlistBlock) return;

  // Remove data-price from ZlistWishlist so theme's variant change
  // handler doesn't replace its content with the price.
  // Runs regardless of whether the Customize button exists.
  var zList = document.getElementById('ZlistWishlist');
  if (zList && zList.hasAttribute('data-price')) {
    zList.removeAttribute('data-price');
  }

  // No Customize button on this product — leave the wishlist block
  // in its normal/original position, nothing to wrap.
  if (!customizeBtn) return;

  // Save original position on first run
  if (!_wishlistOriginalParent) {
    _wishlistOriginalParent  = wishlistBlock.parentElement;
    _wishlistOriginalSibling = wishlistBlock.nextSibling;
  }

  // Already inside the row wrapper — nothing to do
  if (customizeBtn.closest('.customize-wishlist-row')) return;

  var wrapper = document.createElement('div');
  wrapper.className = 'customize-wishlist-row';
  customizeBtn.parentNode.insertBefore(wrapper, customizeBtn);
  wrapper.appendChild(customizeBtn);
  wrapper.appendChild(wishlistBlock);
}

function restoreWishlistToOriginal() {
  var wishlistBlock = document.querySelector('.shopify-app-block[id*="wishlist"]');
  if (!wishlistBlock || !_wishlistOriginalParent) return;

  if (_wishlistOriginalSibling && _wishlistOriginalSibling.parentElement === _wishlistOriginalParent) {
    _wishlistOriginalParent.insertBefore(wishlistBlock, _wishlistOriginalSibling);
  } else {
    _wishlistOriginalParent.appendChild(wishlistBlock);
  }
}

document.addEventListener('DOMContentLoaded', function () {
  applyWishlistLayout();
});



// ── Close mega menu on page scroll (desktop only) ────────────────────────
// The theme's closeAll() function lives inside the Navigation closure and
// isn't exposed globally, so we replicate its exact DOM operations:
//   1. Remove "active" from all open meganavs → hides the panel
//   2. Set aria-hidden="true" on those meganavs
//   3. Set aria-expanded="false" on the trigger that opened it
//   4. Remove "dropdown-active" from the header → hides the shade overlay
//   5. Dispatch the theme's internal headerOverlay:hide event → animates
//      the shade out cleanly (same path as mouseleave / Escape key)
// Only fires on desktop (≥ 720px) so mobile drawer scroll is unaffected.
// A 5px threshold prevents hairline jitter from triggering a close.
// ─────────────────────────────────────────────────────────────────────────
(function () {
  var lastScrollY   = window.scrollY;
  var ticking       = false;
  var SCROLL_THRESHOLD = 5;    // px — ignore tiny jitter
  var DESKTOP_BREAKPOINT = 720; // px — matches Stiletto theme breakpoint

  function closeMeganav() {
    // Only act when the header is actually in a dropdown-active state
    var header = document.querySelector('[data-section-type="header"]');
    if (!header) return;
    if (!header.classList.contains('dropdown-active')) return;

    // 1. Collect all open meganav panels
    var openMenus = header.querySelectorAll('.meganav.active');
    openMenus.forEach(function (menu) {
      menu.classList.remove('active');
      menu.setAttribute('aria-hidden', 'true');
    });

    // 2. Reset all meganav + dropdown triggers (aria-expanded)
    var triggers = header.querySelectorAll(
      '[data-meganav-trigger], [data-dropdown-trigger], [data-parent], [data-link]'
    );
    triggers.forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    });

    // 3. Remove dropdown-active class from header
    header.classList.remove('dropdown-active');

    // 4. Close the shade overlay via the theme's internal event bus
    //    r$1("headerOverlay:hide") is what closeAll() calls internally.
    //    The theme attaches its bus to window.__themeEvents for external use;
    //    if that isn't available we fall back to a direct class removal.
    if (window.__themeEvents && typeof window.__themeEvents.emit === 'function') {
      window.__themeEvents.emit('headerOverlay:hide');
    } else {
      // Fallback: directly hide the overlay element the theme uses
      var overlay = document.querySelector('.header-overlay, [data-overlay]');
      if (overlay) {
        overlay.classList.remove('active', 'visible');
        overlay.setAttribute('aria-hidden', 'true');
      }
    }
  }

  function onScroll() {
    // Desktop only
    if (window.innerWidth < DESKTOP_BREAKPOINT) {
      lastScrollY = window.scrollY;
      ticking = false;
      return;
    }

    var currentScrollY = window.scrollY;
    var delta = Math.abs(currentScrollY - lastScrollY);

    if (delta >= SCROLL_THRESHOLD) {
      closeMeganav();
      lastScrollY = currentScrollY;
    }

    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      window.requestAnimationFrame(onScroll);
      ticking = true;
    }
  }, { passive: true });
})();
(function () {
    const atcButton = document.querySelector('.product-form__cart-submit');
    const variantSelector = document.querySelector('#variant-selector');
    
    // Modal elements
    const customModal = document.querySelector('#preorder-modal');
    const modalTextContainer = document.querySelector('.jl-modal-text');
    const confirmYesBtn = document.querySelector('.jl-btn-yes');
    const confirmNoBtn = document.querySelector('.jl-btn-no');
    
    // IMPORTANT: If popup is disabled in schema or ATC is missing, exit script completely.
    // Standard ATC will function normally.
    if (!atcButton || !customModal) return;

    // Store the default section settings text so we can fall back to it later
    if (modalTextContainer && !modalTextContainer.hasAttribute('data-default-text')) {
        modalTextContainer.setAttribute('data-default-text', modalTextContainer.innerHTML);
    }

    // 1. Initial Load Check: Set class & text for the default variant on load
    if (variantSelector) {
        const initialOption = variantSelector.options[variantSelector.selectedIndex];
        if (initialOption) {
            const initialInv = parseInt(initialOption.getAttribute('data-variant-inventory'), 10) || 0;
            const initialAvail = initialOption.getAttribute('data-available') === 'true';
            
            if (initialAvail && initialInv <= 0) {
                atcButton.classList.add('trigger-preorder-popup');
                
                // Set initial text
                if (modalTextContainer) {
                    const variantText = initialOption.getAttribute('data-variant-delivery-text');
                    if (variantText && variantText.trim() !== '') {
                        modalTextContainer.innerHTML = modalTextContainer.getAttribute('data-default-text').replace('[delivery_message]',variantText);
                    }
                }
            }
        }
    }

    // 2. Intercept ATC Click 
    atcButton.addEventListener('click', function (event) {
        if (atcButton.classList.contains('trigger-preorder-popup')) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation(); 
            customModal.style.display = 'flex';
        }
    }, true); 

    // 3. User Clicks "YES"
    if (confirmYesBtn) {
        confirmYesBtn.addEventListener('click', function () {
            customModal.style.display = 'none';
            atcButton.classList.remove('trigger-preorder-popup');
            
            atcButton.click();
            
            setTimeout(() => {
                atcButton.classList.add('trigger-preorder-popup');
            }, 500);
        });
    }

    // 4. User Clicks "NO"
    if (confirmNoBtn) {
        confirmNoBtn.addEventListener('click', function () {
            customModal.style.display = 'none';
        });
    }
    
    // Close modal on background overlay click
    window.addEventListener('click', function(event) {
        if (event.target === customModal) {
            customModal.style.display = 'none';
        }
    });
})();